<template>
    <div>
        <TitleBar>
            <template v-slot:title><translate>Summary</translate></template>
        </TitleBar>
        <div class="content">

            <!-- TODO: make it a widget visible only for accountants -->
            <CustomerOverview v-if="!loading" :customerDetails="customerDetails" :accountantConnection="accountantConnection" />
            
            <GridContainer v-if="!loading" :dashboard-items="userWidgets"/>
        </div>
    </div>
</template>

<script>
import TitleBar from "@/components/TitleBar"
import GekkoButton from "@/components/GekkoButton";
import CustomerOverview from "@/components/accountants/CustomerOverview";
import AccountantsService from "@/store/services/accountants.service";
import GridContainer from "@/components/dashboard/GridContainer";
import CompanySettingService from "@/store/services/companysetting.service.js";
import { mapGetters } from "vuex";

export default {
    name: 'ControlPanel',
    components: {GekkoButton, TitleBar, CustomerOverview, GridContainer},
    data() {
        return {
            customerDetails: {},
            accountantConnection: {},
            userWidgets: [],
            widgetGlobalDefaults: {
                x: 0, y: 0,
                premium: false,
                noResize: true,
                noMove: false,
                locked: false,
                unique: false,
                noRemove: false
            },
            defaultConfig: [
                { type: 'cashflow-chart',       x: 0, y: 0 },
                { type: 'costs',                x: 9, y: 9 },
                { type: 'invoices',             x: 9, y: 4 }
            ],
            widgetDefaultConfigs: [
                { type: 'cashflow-chart', name: 'Revenue and expenses',  w: 9, h: 10, minH: 8, minW: 3, config: { period: { days: 90 } } },
                { type: 'costs', name: 'Costs overview',                 w: 3, h: 5,  minH: 4,  minW: 2, config: { period: { days: 30 } } },
                { type: 'invoices', name: 'Invoices overview',           w: 3, h: 5,  minH: 4,  minW: 2, config: { period: { days: 30 } } }
            ],
            loading: true
        }
    },
    created() {
        AccountantsService.getCustomerInformation(this.$route.params['customerId']).then((response) => {
            this.customerDetails = response.data

            AccountantsService.getAccountantConnectionList({ customer: this.customerDetails.id }).then((response) => {
                this.accountantConnection = response.data[0] // there must be just one connection per customer
            })
            
            CompanySettingService.retrieve({ company: this.$route.params['customerId'] }).then((response) => {
                const full_dashboard_config = (response.data[0].dashboard_config) ? JSON.parse(response.data[0].dashboard_config) : []
                const user_id = this.customerDetails.created_by.id
                const dashboard_config = (full_dashboard_config[user_id]) ? full_dashboard_config[user_id] : []
                this.userWidgets = (dashboard_config.length) ? dashboard_config : this.getFullDefaultConfig()
                this.loading = false
            })
        })
    },
    computed: {
        ...mapGetters({
            getUserWidgets: "dashboard/getUserWidgets",
            currentCompany: 'main/getCurrentCompany'
        })
    },
    methods: {
        getWidgetDefaults(type) {
            const widget_config = Object.assign({}, this.widgetDefaultConfigs.find(item => item.type === type), {})
            Object.keys(this.widgetGlobalDefaults).forEach(propName => {
                if (propName in widget_config && widget_config[propName] === undefined)
                    widget_config[propName] = this.widgetGlobalDefaults[propName]
            })
            return widget_config
        },
        getFullDefaultConfig() {
            const widgets = []
            this.defaultConfig.forEach(item => {
                widgets.push(Object.assign(this.getWidgetDefaults(item.type), item))
            })
            return widgets
        }
    }

}
</script>

<styles lang="scss">
</styles>